<a class="left center" [href]="prod ? 'https://test.chequeo.de' : 'https://dev.test.chequeo.de'">
    <p>Schüler/in</p>
</a>
<a class="right center" [href]="prod ? 'https://lehrer.chequeo.de' : 'https://dev.lehrer.chequeo.de'">
    <p>Lehrer/in</p>
</a>
